import { createFeature, createReducer, on } from '@ngrx/store';

import {
  CustomerInformationResponse,
  initialStatus,
  LoadingStatus,
} from '@features/succession/interfaces';
import { CustomerInformation, ListBoxItems } from '@features/succession/models';
import * as fromActions from '@features/succession/store/actions';

export const successionFeatureName = 'customerInformation';

export interface CustomerInformationState {
  lastRequest: CustomerInformation | undefined;
  sourcePage: number;
  destinationPage: number;
  loadPage: number;
  customerInformation: CustomerInformation | undefined;
  listBoxItems: ListBoxItems | undefined;
  loadingStatus: LoadingStatus<CustomerInformationResponse['formErrorDTO']>;
}

export const initialState: CustomerInformationState = {
  lastRequest: undefined,
  sourcePage: 0,
  destinationPage: 1,
  loadPage: 1,
  customerInformation: undefined,
  listBoxItems: undefined,
  loadingStatus: initialStatus,
};

export const customerInformationReducer = createReducer(
  initialState,
  on(
    fromActions.CustomerInformationInitializing,
    fromActions.CustomerInformationSaveAndLoad,
    (state, { customerInformation }): CustomerInformationState => ({
      ...state,
      loadingStatus: {
        ...initialStatus,
        isLoading: true,
      },
      lastRequest: customerInformation,
      customerInformation: {
        ...customerInformation,
        deceasedInformations:
          customerInformation.deceasedInformations ||
          state.customerInformation?.deceasedInformations,
        deceasedMoreInformations:
          customerInformation.deceasedMoreInformations ||
          state.customerInformation?.deceasedMoreInformations,
        reporterInformations:
          customerInformation.reporterInformations ||
          state.customerInformation?.reporterInformations,
        notaryInformations:
          customerInformation.notaryInformations || state.customerInformation?.notaryInformations,
        inheritanceInformations:
          customerInformation.inheritanceInformations ||
          state.customerInformation?.inheritanceInformations,
      },
    }),
  ),
  on(fromActions.CustomerInformationSaveAndLoadComplete, (state): CustomerInformationState => ({
    ...state,
    loadingStatus: { ...initialStatus, isLoaded: true },
  })),
  on(
    fromActions.CustomerInformationInitialized,
    fromActions.CustomerInformationPersist,
    (state, { customerInformation, selfCareListValues }): CustomerInformationState => ({
      ...state,
      loadingStatus: {
        ...initialStatus,
        isLoaded: true,
      },
      loadPage: Number(customerInformation.loadPage),
      customerInformation: {
        ...customerInformation,
        deceasedInformations:
          customerInformation.deceasedInformations ||
          state.customerInformation?.deceasedInformations,
        deceasedMoreInformations:
          customerInformation.deceasedMoreInformations ||
          state.customerInformation?.deceasedMoreInformations,
        reporterInformations:
          customerInformation.reporterInformations ||
          state.customerInformation?.reporterInformations,
        notaryInformations:
          customerInformation.notaryInformations || state.customerInformation?.notaryInformations,
        inheritanceInformations:
          customerInformation.inheritanceInformations ||
          state.customerInformation?.inheritanceInformations,
      },
      listBoxItems: selfCareListValues,
    }),
  ),
  on(
    fromActions.CustomerInformationInitializingError,
    fromActions.CustomerInformationSaveAndLoadError,
    (state, { error }): CustomerInformationState => ({
      ...state,
      loadingStatus: {
        ...initialStatus,
        error,
      },
    }),
  ),
  on(fromActions.CustomerInformationResetWorkflow, (): CustomerInformationState => ({
    ...initialState,
  })),
);

export const successionFeature = createFeature({
  name: successionFeatureName,
  reducer: customerInformationReducer,
});
